const ContainerSecondary = ({ children }) => {
  return (
    <>
      <div className=" bg-secondary p-8 pb-20 text-primary">{children}</div>
    </>
  );
};

export default ContainerSecondary;
